import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UpdateStatus } from 'modules/settings/submodules/platformUsers/components/UpdateStatus/UpdateStatus';
import { Status } from 'shared/models/Status';
import { selectIsActivityStatusUpdating } from 'modules/settings/submodules/clients/activities/components/ClientActivitiesTable/components/UpdateStatusSelect/store/selectors';
import { setActivityStatus } from 'modules/settings/submodules/clients/activities/components/ClientActivitiesTable/components/UpdateStatusSelect/store/actions';

export interface IUpdateActivityStatusSelectProps {
    id: string;
    status: Status;
    className?: string;
}

export const UpdateActivityStatusSelect = (props: IUpdateActivityStatusSelectProps) => {
    const { id, status, className } = props;
    const dispatch = useDispatch();
    const isLoading = useSelector(selectIsActivityStatusUpdating);
    const handleStatusChange = useCallback((newValue: Status) => {
        dispatch(setActivityStatus.init({
            id,
            status: newValue,
        }));
    }, [dispatch, id]);

    return (
        <UpdateStatus
            status={status}
            handleStatusChange={handleStatusChange}
            isLoading={isLoading}
            formControlClassName={className}
        />
    );
};
